import styled, { keyframes } from 'styled-components'

// ── Indeterminate spinner ─────────────────────────────────────────────────────
//
// A short colored arc that rotates continuously around the badge ring. Matches
// the canonical "still working" pattern users already recognise from native
// loaders — clearer signal than a pulsing dot, and reads correctly at 26 px.
//
// The arc is rendered inside this <g> wrapper so the rotation transform
// applies cleanly without disturbing the static track ring underneath.

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
`

export const SpinnerGroup = styled.g`
  transform-origin: center;
  transform-box: view-box;
  animation: ${rotate} 0.9s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation-duration: 2.4s;
  }
`

export const BadgeWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
  flex-shrink: 0;
`
